import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import SectionHeader from "../components/SectionHeader";
import { templatePageDiv } from "../styles/style";
import linkedin from "../icons/linkedin2.svg";
import github from "../icons/github2.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faEnvelope as newEmail,
  faUser,
} from "@fortawesome/free-regular-svg-icons";

const Contact = () => {
  return (
    <ContactPage id="contact">
      <div className="gradient bg-overlay"></div>
      <div className="gradient bg-overlay"></div>
      <div className="gradient gradient-2 bg-overlay"></div>
      <SectionHeader title={"CONTACT"} />

      <div className="container">
        <div className="shell">
          <Info>
            <div className="intro">
              <h3>Get In Touch.</h3>
              <p>Fill out the form below or click my contact links.</p>
            </div>

            <div className="contact-btns">
              <button>
                <span>
                  <FontAwesomeIcon size="1x" icon={faPhoneAlt} />
                </span>
                <a href="tel:+16479094XXX">+1 647-909-4XXX</a>
              </button>
              <button>
                <span>
                  <FontAwesomeIcon size="1x" icon={faEnvelope} />
                </span>
                <a href="mailto:v.santharupan@gmail.com">
                  v.santharupan@gmail.com
                </a>
              </button>
            </div>

            <div className="social-link-container">
              <div className="social-bubbles">
                <a
                  href="https://github.com/VishnuRupan"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={github} alt="GitHub.com/VishnuRupan" />
                </a>
              </div>
              <div className="social-bubbles">
                <a
                  href="https://www.linkedin.com/in/vishnu-santharupan"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={linkedin}
                    alt="linkedin.com/in/vishnu-santharupan"
                  />
                </a>
              </div>
            </div>
          </Info>

          <FormContainer>
            <form
              name="contact"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
              onSubmit="submit"
            >
              <input type="hidden" name="form-name" value="contact" />
              <div className="name-field wrapper">
                <label htmlFor="name">Your Name</label>

                <div className="input-wrapper">
                  <FontAwesomeIcon className="font-icon" icon={faUser} />
                  <input type="text" id="name" name="name" required />
                </div>
              </div>

              <div className="email-field wrapper">
                <label htmlFor="email">Email</label>

                <div className="input-wrapper">
                  <FontAwesomeIcon className="font-icon" icon={newEmail} />
                  <input type="email" id="email" name="email" required />
                </div>
              </div>

              <div className="message-field wrapper">
                <label htmlFor="message">Message</label>

                <div className="input-wrapper">
                  <textarea
                    rows="6"
                    id="message"
                    name="message"
                    required
                  ></textarea>
                </div>
              </div>

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </FormContainer>
        </div>
      </div>
    </ContactPage>
  );
};

const ContactPage = styled(templatePageDiv)`
  padding-top: 3rem;
  background: transparent;

  .gradient {
    background-image: linear-gradient(#0c0c0c, transparent);
    opacity: 1;
    position: absolute;
    height: 100%;
  }

  .gradient-2 {
    opacity: 1;
    position: absolute;
  }

  .shell {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 800px) {
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
  }
`;

const Info = styled(motion.div)`
  min-height: 25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  h3 {
    font-family: "Work Sans", sans-serif;
    font-size: 4.5rem;

    @media (max-width: 1024px) {
      font-size: 3.5rem;
    }

    @media (max-width: 800px) {
      font-size: 2.5rem;
    }

    @media (max-width: 400px) {
      font-size: 2rem;
    }
  }

  p {
    padding-top: 1rem;
    font-weight: 300;
    font-size: 1.1rem;
    color: #e9e9e9;

    @media (max-width: 1024px) {
      font-size: 0.9rem;
    }

    @media (max-width: 800px) {
      font-size: 0.8rem;
      padding-bottom: 1.5rem;
    }
  }

  @media (max-width: 800px) {
    text-align: center;
    align-items: center;
    min-height: 15rem;
  }

  .contact-btns {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 800px) {
      align-items: center;
    }

    span {
      margin-right: 1rem;
    }

    button {
      border: 1px transparent solid;
      background: none;
      color: white;
      padding: 1rem 1rem;
      font-weight: 600;
      letter-spacing: 0.02rem;
      margin: 0.2rem 0rem;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35);
      background: #0e0e0e;

      a {
        color: white;
        text-decoration: none;
        font-weight: bold;
      }

      &:hover {
        border: 1px solid white;
        border-radius: 0.1rem;
      }
    }
  }

  .social-link-container {
    display: flex;

    .social-bubbles {
      padding: 0.9rem;
      border-radius: 100%;
      margin-right: 2rem;
      cursor: pointer;

      @media (max-width: 800px) {
        margin-top: 1rem;
        margin-right: 0rem;
        margin-bottom: 1rem;
      }

      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background: linear-gradient(101deg, #962dce, #6de8fb);
      }

      img {
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }
`;

const FormContainer = styled(motion.div)`
  padding: 1rem 1.5rem;
  background: transparent;
  border-radius: 0.1rem;
  color: #ffffff;

  form {
    width: 25rem;

    @media (max-width: 1024px) {
      width: 20rem;
    }

    @media (max-width: 800px) {
      width: 15rem;
      margin-bottom: 3rem;
    }
  }

  button {
    font-size: 0.9rem;
    margin-top: 1rem;
    font-weight: bold;
    padding: 0.5rem 1.7rem;
    color: white;
    border: solid 3px transparent;
    border-radius: 0.1rem;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0)
      ),
      linear-gradient(101deg, #962dce, #6de8fb);
    background-origin: border-box;
    background-clip: content-box, border-box;
    font-family: "Work Sans", sans-serif;
    a {
      color: white;
      text-decoration: none;
    }
    :hover {
      box-shadow: none;
      color: white;
    }

    :active {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35),
        inset 0px 4px 4px rgba(0, 0, 0, 0.35);
    }

    :focus {
      outline: none;
    }
  }

  .wrapper {
    padding: 0.5rem 0rem;
  }

  .input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #d5d5d5;
    padding: 0rem 0.4rem;
    border-radius: 0.1rem;
    margin: 0.3rem 0rem;

    .font-icon {
      color: #c6c6c6;
    }
  }

  label {
    font-size: 0.7rem;
    color: #ffffff;
  }

  input {
    margin-left: 0.5rem;
  }

  textarea {
    resize: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #0c0c0c inset !important;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: #ffffff !important;
  }

  textarea,
  input {
    background: transparent;
    color: #ffffff;
    width: 100%;
    border: none;
    padding: 0.5rem 0.3rem;
    line-height: 1.2rem;
    &:focus,
    &:active {
      outline: none;
      background: transparent;
    }
  }
`;

export default Contact;
